export default __webpack_public_path__ + "static/media/lv.e17f4986.svg";